var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"endTime":_vm.endTime,"endText":_vm.endText}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }